import React, { useEffect } from 'react';
import Navbar from './Navbar';
import { useLocation, Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Youtube, ChevronRight } from 'lucide-react';

import schoolLogo from '../school_logo.jpg';

const Layout = ({ children }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <div className="flex flex-col min-h-screen font-sans text-gray-800">
            <Navbar />
            <main className="flex-grow">
                {children}
            </main>

            {/* Fat Footer */}
            <footer className="bg-gray-900 text-white pt-20 pb-10 border-t border-gray-800">
                <div className="container grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
                    {/* Column 1: Brand & About */}
                    <div className="space-y-6">
                        <Link to="/" className="text-3xl font-black font-serif text-white flex items-center gap-2">
                            <img src={schoolLogo} alt="TCM Logo" className="w-12 h-12 rounded-full object-cover border-2 border-secondary" />
                            TCM Matric
                        </Link>
                        <p className="text-gray-400 leading-relaxed text-sm">
                            Empowering students with knowledge, character, and skills for over 30 years. We are an institution dedicated to holistic excellence and global citizenship.
                        </p>
                        <div className="flex gap-4">
                            <a href="https://www.facebook.com/profile.php?id=61578302762657" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center hover:bg-secondary hover:text-primary transition-all"><Facebook size={18} /></a>
                            <a href="https://www.instagram.com/tcm_matriculation_school/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center hover:bg-secondary hover:text-primary transition-all"><Instagram size={18} /></a>
                            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="Youtube" className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center hover:bg-secondary hover:text-primary transition-all"><Youtube size={18} /></a>
                            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center hover:bg-secondary hover:text-primary transition-all"><Twitter size={18} /></a>
                        </div>
                    </div>

                    {/* Column 2: Quick Links */}
                    <div>
                        <h4 className="text-lg font-bold text-white mb-6 border-b border-gray-700 pb-2 inline-block">Quick Links</h4>
                        <ul className="space-y-3 text-gray-400 text-sm">
                            {['About Us', 'Admissions', 'Academics', 'Gallery', 'Contact Us', 'Alumni Network'].map(item => (
                                <li key={item}>
                                    <Link to={`/${item.toLowerCase().replace(' ', '')}`} className="hover:text-secondary flex items-center gap-2 transition-colors">
                                        <ChevronRight size={14} className="text-secondary" /> {item}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Column 3: Academic Wings */}
                    <div>
                        <h4 className="text-lg font-bold text-white mb-6 border-b border-gray-700 pb-2 inline-block">Academics</h4>
                        <ul className="space-y-3 text-gray-400 text-sm">
                            {['Kindergarten (KG)', 'Primary School', 'Middle School', 'High School', 'Higher Secondary', 'Sports Academy'].map(item => (
                                <li key={item} className="flex items-center gap-2">
                                    <div className="w-1.5 h-1.5 bg-gray-600 rounded-full"></div> {item}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Column 4: Contact Info */}
                    <div>
                        <h4 className="text-lg font-bold text-white mb-6 border-b border-gray-700 pb-2 inline-block">Get in Touch</h4>
                        <ul className="space-y-6 text-gray-400 text-sm">
                            <li className="flex gap-4">
                                <MapPin className="shrink-0 text-secondary" size={20} />
                                <span>
                                    Sandaipettai, Sennampatti (638504),<br />
                                    Chennampatti, Ammapettai - Erode,<br />
                                    Tamil Nadu.
                                </span>
                            </li>
                            <li className="flex gap-4">
                                <Phone className="shrink-0 text-secondary" size={20} />
                                <div className="flex flex-col">
                                    <a href="tel:+919750978888" className="hover:text-white transition-colors">+91 97509 78888</a>
                                    <a href="tel:+919500868888" className="hover:text-white transition-colors">+91 9500868888</a>
                                </div>
                            </li>
                            <li className="flex gap-4">
                                <Mail className="shrink-0 text-secondary" size={20} />
                                <a href="mailto:bharathi@tcmmatricschool.in" className="hover:text-white transition-colors">bharathi@tcmmatricschool.in</a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Sub Footer */}
                <div className="container pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500">
                    <p>© {new Date().getFullYear()} TCM Matriculation School. All rights reserved.</p>
                    <div className="flex gap-6">
                        <Link to="#" className="hover:text-white transition-colors">Privacy Policy</Link>
                        <Link to="#" className="hover:text-white transition-colors">Terms of Service</Link>
                        <Link to="#" className="hover:text-white transition-colors">Sitemap</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
};
export default Layout;
